import { render, staticRenderFns } from "./UserLikeMeComponent.vue?vue&type=template&id=2e8a0cbc&scoped=true"
import script from "./UserLikeMeComponent.vue?vue&type=script&lang=js"
export * from "./UserLikeMeComponent.vue?vue&type=script&lang=js"
import style0 from "./UserLikeMeComponent.vue?vue&type=style&index=0&id=2e8a0cbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8a0cbc",
  null
  
)

export default component.exports